/* global Office */

/**
 * taskpane.js — Point d'entrée unique.
 *
 * Ce fichier fait UNE seule chose :
 * attendre qu'Office.js soit prêt, puis monter l'application React.
 *
 * Toute la logique est dans App.jsx et ses composants.
 * On n'appelle Office.onReady qu'une seule fois dans toute l'application.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

Office.onReady(() => {
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
});